module.exports = __webpack_public_path__ + "files/096d0c2187e462c4463721e36df05884.svg";